// import React, { useEffect, useState } from "react";
// import { Plus } from "lucide-react";
// import { useNavigate } from "react-router-dom";
// import api from "../../common/apiClient";
// import summaryApi from "../../common/SummaryApi";
// import { MdKeyboardArrowRight } from "react-icons/md";
// /* ===================== DUMMY BEST SELLERS ===================== */
// const bestSellers = [
//   { name: "Deco accessory", price: 21.19, sold: 409, profit: 1822.87 },
//   { name: "Pottery Vase", price: 14.18, sold: 396, profit: 8545.25 },
//   { name: "Rose Holdback", price: 18.15, sold: 243, profit: 7287.01 },
//   { name: "Flowering Cactus", price: 74.16, sold: 636, profit: 9325.47 },
// ];

// /* ===================== DUMMY PRODUCTS (RIGHT SIDE) ===================== */
// const quickProducts = [
//   {
//     name: "Smart Fitness Tracker",
//     price: 39.99,
//     image: "https://via.placeholder.com/60",
//   },
//   {
//     name: "Leather Wallet",
//     price: 19.99,
//     image: "https://via.placeholder.com/60",
//   },
//   {
//     name: "Electric Hair Trimmer",
//     price: 34.99,
//     image: "https://via.placeholder.com/60",
//   },
//   {
//     name: "Wireless Earbuds",
//     price: 49.99,
//     image: "https://via.placeholder.com/60",
//   },
// ];

// const DashboardQuickAddSection = () => {
//   const navigate = useNavigate();

//   const [categories, setCategories] = useState([]);
//   const [loading, setLoading] = useState(false);

//   /* ===================== FETCH CATEGORIES ===================== */
//   const fetchCategories = async () => {
//     try {
//       setLoading(true);
//       const res = await api({
//         url: summaryApi.getAllTopCategories.url,
//         method: summaryApi.getAllTopCategories.method,
//       });

//       setCategories(res?.data?.data || []);
//     } catch (err) {
//       console.error("Category fetch error", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchCategories();
//   }, []);

//   return (
//     <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">
//       {/* ===================== BESTSELLERS ===================== */}
//       <div className="bg-white rounded-2xl shadow-sm p-6">
//         <div className="flex justify-between items-center mb-4">
//           <h3 className="text-base font-semibold text-gray-800">
//             Bestsellers
//           </h3>
//           <button
//             onClick={() => navigate("/admin-panel/bestsellers")}
//             className="text-sm text-blue-600 hover:underline"
//           >
//             More →
//           </button>
//         </div>

//         <table className="w-full text-sm">
//           <thead className="text-gray-400 border-b">
//             <tr>
//               <th className="text-left py-2">Product</th>
//               <th>Price</th>
//               <th>Sold</th>
//               <th>Profit</th>
//             </tr>
//           </thead>
//           <tbody>
//             {bestSellers.map((item, i) => (
//               <tr key={i} className="border-b last:border-0">
//                 <td className="py-3 text-gray-700">{item.name}</td>
//                 <td>${item.price}</td>
//                 <td>{item.sold}</td>
//                 <td className="text-green-600 font-medium">
//                   ${item.profit}
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>

//       {/* ===================== ADD NEW PRODUCT ===================== */}
//       <div className="bg-white  p-6">
//         <div className="flex justify-between items-center mb-4">
//           <h3 className="text-base font-semibold text-gray-800">
//             Add New Product
//           </h3>
//           <button
//             onClick={() => navigate("/admin-panel/all-products")}
//             className="text-sm text-blue-600 flex items-center gap-1 hover:underline"
//           >
//             <Plus size={14} /> Add New
//           </button>
//         </div>

//         <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//           {/* ===================== CATEGORIES ===================== */}
//           <div>
//             <p className="text-xs text-gray-400 mb-2">Categories</p>

//             {loading && (
//               <p className="text-sm text-gray-400">Loading...</p>
//             )}

//             {categories.slice(0, 4).map((cat) => (
//               <button
//                 key={cat._id}
//                 onClick={() =>
//                   navigate(`/admin-panel/products?category=${cat._id}`)
//                 }
//                 className="w-full flex justify-between items-center px-2 py-3 rounded-md mb-2 shadow-md"
//               >
//                 <div className="flex items-center gap-3">
//                   <div className="border rounded-lg shadow-lg">
//                   <img
//                     src={cat.image || "https://via.placeholder.com/40"}
//                     alt=""
//                     className="w-10 h-10 rounded-md object-cover"
//                   />
//                   </div>
//                   <span className="font-medium text-gray-700">
//                     {cat.name}
//                   </span>
//                 </div>
//                 <span className="text-gray-400"><MdKeyboardArrowRight size={20}/></span>
//               </button>
//             ))}
//           <div className="text-center">  
//             <button
//               onClick={() => navigate("/admin-panel/all-categories")}
//               className="text-sm text-blue-600 mt-2 hover:underline"
//             >
//               See more
//             </button>
//           </div>
//           </div>

//           {/* ===================== PRODUCTS ===================== */}
//           <div>
//             <p className="text-xs text-gray-400 mb-2">Product</p>

//             {quickProducts.slice(0, 4).map((prod, i) => (
//               <div
//                 key={i}
//                 className="flex justify-between items-center p-3 border rounded-xl mb-2"
//               >
//                 <div className="flex items-center gap-3">
//                   <img
//                     src={prod.image}
//                     alt=""
//                     className="w-10 h-10 rounded-lg object-cover"
//                   />
//                   <div>
//                     <p className="text-sm font-medium text-gray-700 truncate w-32 xl:w-20">
//                       {prod.name}
//                     </p>
//                     <p className="text-sm text-blue-600">
//                       ${prod.price}
//                     </p>
//                   </div>
//                 </div>
//                 <button
//                   onClick={() =>
//                     navigate("/admin-panel/all-products")
//                   }
//                   className="bg-blue-600 text-white px-3 py-1.5 text-xs rounded-lg hover:bg-blue-700"
//                 >
//                   + Edit
//                 </button>
//               </div>
//             ))}
//           <div className="text-center">  
//             <button
//               onClick={() => navigate("/admin-panel/all-products")}
//               className="text-sm text-blue-600 mt-2 hover:underline"
//             >
//               See more
//             </button>
//           </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default DashboardQuickAddSection;


import React, { useEffect, useState } from "react";
import { Plus } from "lucide-react";
import { MdKeyboardArrowRight } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import api from "../../common/apiClient";
import summaryApi from "../../common/SummaryApi";

/* ===================== COMPONENT ===================== */
const DashboardQuickAddSection = () => {
  const navigate = useNavigate();

  const [categories, setCategories] = useState([]);
  const [bestSellers, setBestSellers] = useState([]);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);

  /* ===================== FETCH CATEGORIES ===================== */
  const fetchCategories = async () => {
    try {
      const res = await api({
        url: summaryApi.getAllTopCategories.url,
        method: summaryApi.getAllTopCategories.method,
      });

      setCategories(res?.data?.data || []);
    } catch (err) {
      console.error("Category fetch error", err);
    }
  };

  /* ===================== FETCH BEST SELLERS ===================== */
  const fetchBestSellers = async () => {
    try {
      const res = await api({
        url: summaryApi.getBestSellers.url, // 👈 add in SummaryApi
        method: summaryApi.getBestSellers.method,
      });

      if (res?.data?.success) {
        setBestSellers(res.data.products || []);
      }
    } catch (err) {
      console.error("Best seller fetch error", err);
    }
  };

  /* ===================== FETCH PRODUCTS ===================== */
  const fetchProducts = async () => {
    try {
      const res = await api({
        url: summaryApi.getAllProducts.url,
        method: summaryApi.getAllProducts.method,
      });
      console.log(res.data.products);
      
      setProducts(res?.data?.products || []);
    } catch (err) {
      console.error("Product fetch error", err);
    }
  };

  useEffect(() => {
    setLoading(true);
    Promise.all([fetchCategories(), fetchBestSellers(), fetchProducts()])
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">
      {/* ===================== BESTSELLERS ===================== */}
      <div className="bg-white rounded-2xl shadow-sm p-6">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-base font-semibold text-gray-800">
            Bestsellers
          </h3>
          {/* <button
            onClick={() => navigate("/admin-panel/bestsellers")}
            className="text-sm text-blue-600 hover:underline"
          >
            More →
          </button> */}
        </div>

<table className="w-full text-sm table-fixed">
  <thead className="text-gray-400 border-b">
    <tr>
      <th className="text-left py-2 w-[55%]">Product</th>
      <th className="text-right py-2 w-[15%]">Price</th>
      <th className="text-right py-2 w-[15%]">Sold</th>
      <th className="text-right py-2 w-[15%]">Profit</th>
    </tr>
  </thead>

  <tbody>
    {loading ? (
      <tr>
        <td
          colSpan={4}
          className="py-6 text-center text-sm text-gray-400"
        >
          Loading bestsellers...
        </td>
      </tr>
    ) : (
      bestSellers.slice(0, 4).map((item) => (
        <tr
          key={item.productId}
          className="border-b last:border-0"
        >
          {/* PRODUCT */}
          <td className="py-3">
            <div className="flex items-center gap-3">
              <img
                src={item.image}
                alt=""
                className="w-9 h-9 rounded-md object-cover shrink-0"
              />
              <span className="text-gray-700 line-clamp-1">
                {item.productName}
              </span>
            </div>
          </td>

          {/* PRICE */}
          <td className="text-right text-gray-700">
            ₹{item.price}
          </td>

          {/* SOLD */}
          <td className="text-right text-gray-700">
            {item.sold}
          </td>

          {/* PROFIT */}
          <td className="text-right text-green-600 font-medium">
            ₹{item.profit}
          </td>
        </tr>
      ))
    )}
  </tbody>
</table>

      </div>

      {/* ===================== ADD NEW PRODUCT ===================== */}
      <div className="bg-white p-6 rounded-2xl shadow-sm">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-base font-semibold text-gray-800">
            Add New Product
          </h3>
          <button
            onClick={() => navigate("/admin-panel/all-products")}
            className="text-sm text-blue-600 flex items-center gap-1 hover:underline"
          >
            <Plus size={14} /> Add New
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* ===================== CATEGORIES ===================== */}
          <div>
            <p className="text-xs text-gray-400 mb-2">Categories</p>

            {categories.slice(0, 4).map((cat) => (
              <button
                key={cat._id}
                onClick={() =>
                  navigate(`/admin-panel/all-products/upload?topCategory=${cat._id}`)
                }
                className="w-full flex justify-between items-center px-2 py-3 rounded-md mb-2 shadow-sm hover:bg-gray-50"
              >
                <div className="flex items-center gap-3">
                  <img
                    src={cat.image || "https://via.placeholder.com/40"}
                    alt=""
                    className="w-10 h-10 rounded-md object-cover"
                  />
                  <span className="font-medium text-gray-700">
                    {cat.name}
                  </span>
                </div>
                <MdKeyboardArrowRight size={20} className="text-gray-400" />
              </button>
            ))}

            <div className="text-center">
              <button
                onClick={() => navigate("/admin-panel/all-categories")}
                className="text-sm text-blue-600 mt-2 hover:underline"
              >
                See more
              </button>
            </div>
          </div>

          {/* ===================== PRODUCTS ===================== */}
          <div>
            <p className="text-xs text-gray-400 mb-2">Product</p>

            {products.slice(0, 4).map((prod) => (
              <div
                key={prod._id}
                className="flex justify-between items-center p-3 border rounded-xl mb-2"
              >
                <div className="flex items-center gap-3">
                  <img
                    src={prod.previewImage}
                    alt=""
                    className="w-10 h-10 rounded-lg object-cover"
                  />
                  <div>
                    <p className="text-sm font-medium text-gray-700 truncate w-32 xl:w-20">
                      {prod.productName}
                    </p>
                    <p className="text-sm text-blue-600">
                      ₹{prod?.variants[0]?.sizes[0]?.price}
                    </p>
                  </div>
                </div>

                <button
                  onClick={() =>
                    navigate(`/admin-panel/all-products/upload/${prod._id}`)
                  }
                  className="bg-blue-600 text-white px-3 py-1.5 text-xs rounded-lg hover:bg-blue-700"
                >
                  + Edit
                </button>
              </div>
            ))}

            <div className="text-center">
              <button
                onClick={() => navigate("/admin-panel/all-products")}
                className="text-sm text-blue-600 mt-2 hover:underline"
              >
                See more
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardQuickAddSection;
